import { ListItemText, ListItemIcon } from "@mui/material";
import { Link } from "react-router-dom";
import {
  Computer,
  Analytics,
  Person,
  Build,
  Collections,
  QueryStats,
  CalendarMonth,
  SafetyDivider,
  Tune,
} from "@mui/icons-material";
import StyledListItemButton from "./StyledListItemButton";
import MenuWithSubmenu from "./MenuWithSubmenu";
import MenuProdutividadeLink from "./MenuProdutividadeLink";
import ReorderIcon from "@mui/icons-material/Reorder";
import GroupsIcon from "@mui/icons-material/Groups";
import ListIcon from '@mui/icons-material/List';
import ComputerIcon from "@mui/icons-material/Computer";
import PersonIcon from "@mui/icons-material/Person";
import WorkIcon from "@mui/icons-material/Work";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";

export const mainListItems = (
  <>
    <StyledListItemButton component={Link} to="/home">
      <ListItemIcon>
        <Analytics sx={{ color: "#3ab1e9" }} />
      </ListItemIcon>
      <ListItemText primary="Resumo" />
    </StyledListItemButton>

    <MenuProdutividadeLink>
      <ListItemIcon>
        <QueryStats sx={{ color: "#3a5ae9c9" }} />
      </ListItemIcon>
      <ListItemText primary="Aproveitamento" />
    </MenuProdutividadeLink>

    <StyledListItemButton component={Link} to="/relatorios">
      <ListItemIcon>
        <ReorderIcon sx={{ color: "#f4793c" }} />
      </ListItemIcon>
      <ListItemText primary="Relatórios" />
    </StyledListItemButton>
  </>
);

export const moreListItems = (
  <>
    <MenuWithSubmenu
      title="Colaboradores"
      icon={<AccountBoxIcon />}
      color="#3ab1e9"
      items={[
        {
          primary: "Colaborador",
          to: "/colaboradores",
          icon: <PersonIcon />,
          color: "#3ab1e9",
        },

        {
          primary: "Computador",
          to: "/computadores",
          icon: <ComputerIcon />,
          color: "#3ab1e9",
        },

        {
          primary: "Jornada",
          to: "/jornadas",
          icon: <CalendarMonth />,
          color: "#3ab1e9",
        },

        {
          primary: "Grupo",
          to: "/grupos",
          icon: <GroupsIcon />,
          color: "#3ab1e9",
        },
      ]}
    />

    <MenuWithSubmenu
      title="Gestores"
      icon={<WorkIcon />}
      color="#3a5ae9c9"
      items={[
        {
          primary: "Gestor",
          to: "/usuarios",
          icon: <AccountCircleIcon />,
          color: "#3a5ae9c9",
        },

        {
          primary: "Perfil",
          to: "/perfis/lista",
          icon: <SafetyDivider />,
          color: "#3a5ae9c9",
        },
      ]}
    />

    <MenuWithSubmenu
      title="Configurações"
      icon={<Build />}
      color="#f4793c"
      items={[
        {
          primary: "Gerais",
          to: "/config",
          icon: <Tune />,
          color: "#f4793c",
        },
        {
          primary: "Menu",
          to: "/menu",
          icon: <ListIcon />,
          color: "#f4793c",
        },
      ]}
    />

  </>
);

export const secondaryListItems = (
  <>
    <StyledListItemButton component={Link} to="/image-gallery">
      <ListItemIcon>
        <Collections sx={{ color: "#3a5ae9" }} />
      </ListItemIcon>
      <ListItemText primary="Galeria de Imagens" />
    </StyledListItemButton>
  </>
);

/**
 * Agora sairListItems recebe a função onLogout
 */
export const sairListItems = (onLogout) => (
  <>
    <StyledListItemButton onClick={onLogout}>
      <ListItemIcon>
        <PowerSettingsNewIcon sx={{ color: "rgb(0, 0, 0)" }} />
      </ListItemIcon>
      <ListItemText primary="Sair" />
    </StyledListItemButton>
  </>
);
